import type { JSX } from "react";

import { swSettings } from "app/common/services/swSettings";
import { getBaseUrl } from "app/components/sidebar3/primary-side-bar/utils";
import { allTrackers } from "app/services/track/track";
import type { ISubscriptionSolution } from "app/user-data/solutionBaseInterfaces";
import { buildSwitchAccountUrl, CUE_URL } from "app/user-data/Solutions";

import * as SC from "./styles";

const DATA_AUTOMATION_BUTTON = "cue-sidebar-button";

type CueSidebarButtonProps = {
    isCollapsed: boolean;
    cueSubscription: ISubscriptionSolution;
};

export const CueSidebarButton = ({ isCollapsed, cueSubscription }: CueSidebarButtonProps): JSX.Element => {
    const onButtonClick = (): void => {
        allTrackers.dispatchTrackEvent("side menu", "click", "cue");

        if (cueSubscription.UserId === swSettings.user.id) {
            window.open(CUE_URL, "_blank", "noopener,noreferrer");
            return;
        }

        window.location.href = buildSwitchAccountUrl(
            getBaseUrl(swSettings.swsites.login_handler),
            cueSubscription.UserId,
            CUE_URL,
        );
    };

    return (
        <SC.Wrapper
            isCollapsed={isCollapsed}
            onClick={onButtonClick}
            data-automation={DATA_AUTOMATION_BUTTON}
        >
            <SC.Logo isCollapsed={isCollapsed} />
            <SC.Label isCollapsed={isCollapsed}>Cue</SC.Label>
        </SC.Wrapper>
    );
};
